import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Modal from '../../../Modal';
import Button from '../../../Buttons/Button';

const ConfirmModal = ({
  title,
  description,
  confirmButtonContent = 'Okay',
  className,
  onConfirm,
  onClose,
}) => {
  const handleModalClose = () => {
    onClose();
  };

  return (
    <Modal
      open
      size="xs"
      closeButtonIconClass="hicon-close-2"
      modalClassName={cx('export-confirm-modal', className)}
      onClose={handleModalClose}
    >
      <div className="export-confirm-modal__body">
        <h3 className="h3 export-confirm-modal__title">{title}</h3>
        {description && (
          <p className="export-confirm-modal__description">{description}</p>
        )}
      </div>
      <div className="export-confirm-modal__actions">
        <Button
          size="lg"
          variant="secondary"
          onClick={handleModalClose}
        >
          Cancel
        </Button>

        <Button
          size="lg"
          onClick={() => onConfirm()}
        >
          {confirmButtonContent}
        </Button>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  title: T.node.isRequired,
  description: T.node,
  confirmButtonContent: T.node,
  className: T.string,
  onConfirm: T.func.isRequired,
  onClose: T.func.isRequired,
};

export default ConfirmModal;
